/* eslint-disable @typescript-eslint/no-unused-vars */
import { Alert, Box, Button, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress, MenuItem, Paper, Select, Snackbar, SnackbarCloseReason, FormControl, InputLabel } from '@mui/material';
import { useState } from 'react';
import { AutoCompleteGrupoDeProdutos, AutoCompleteGrupoDeProdutos01, AutoCompleteSubgrupoProdutos01 } from '../../../shared/forms';
import dayjs from 'dayjs';
import { RelatorioEstoqueService } from '../../../shared/services/api/estoque/relatorios/ServiceRelatorioVendas';
import { NavBarRelatoriosEstoque } from '../../../shared/components/navbar/NavBarRelatoriosEstoque';
import RelatorioEstoquepdf from './Restoque';


type ProdutoEstoque = {
  ean: string;
  descricao: string;
  localizado: string;
  preco: number;
  un: string;
  referencia: string | null;
  pvenda: number;
  marca: string;
  idgrupo: string;
  quan: number;
  totalcompra: number;
  total: number;
}
export const RelatorioEstoque: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [openmsg, setOpenmsg] = useState(false);
  const [grupo, setGrupo] = useState('');
  const [subgrupo, setSubGrupo] = useState('');
  const [grupoNome, setGrupoNome] = useState('');
  const [subgrupoNome, setSubgrupoNome] = useState('');
  const [tipo, setTipo] = useState('geral');
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };

  const handleTipoChange = (value: string) => {
    setTipo(value);

    if (value === 'geral') {
      setGrupo('');
      setSubGrupo('');
    }

    if (value === 'grupo') {
      setSubGrupo('');
    }
  };

  const handleSave = () => {
    setIsLoading(true);
    let tituloRelatorio = '';

    if (tipo === 'geral') {
      tituloRelatorio = 'Relatório de Estoque Geral';
    }

    if (tipo === 'grupo') {
      tituloRelatorio = `Relatório de Estoque por Grupo: ${grupoNome}`;
    }

    if (tipo === 'subgrupo') {
      tituloRelatorio = `Relatório de Estoque por Grupo: ${grupoNome} / Subgrupo: ${subgrupoNome}`;
    }

    if (tipo === 'minimo') {
      tituloRelatorio = 'Relatório de Produtos em Estoque Mínimo';
    }
    const dataAtual = dayjs().format('DD/MM/YYYY');
    RelatorioEstoqueService
      .Restoque(grupo, subgrupo, tipo)
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          if (result.length > 0) {
            RelatorioEstoquepdf(
              result as ProdutoEstoque[],
              `${tituloRelatorio}\nData do relatório: ${dataAtual}`
            );
          } else {
            setTms('warning');
            setMsg('Nenhum registro encontrado');
            setOpenmsg(true);
          }
        }
      });
  };
  const handleGrupo = (uuidgrupo: string | undefined, nome?: string) => {
    if (uuidgrupo) {
      setGrupo(uuidgrupo);
      setGrupoNome(nome ?? '');
      setSubGrupo('');
      setSubgrupoNome('');
    } else {
      setGrupo('');
      setGrupoNome('');
      setSubGrupo('');
      setSubgrupoNome('');
    }
  };
  const handleSubGrupo = (uuidsubgrupo: string | undefined, nome?: string) => {
    if (uuidsubgrupo) {
      setSubGrupo(uuidsubgrupo);
      setSubgrupoNome(nome ?? '');
    } else {
      setSubGrupo('');
      setSubgrupoNome('');
    }
  };
  return (
    <Box
      alignItems="center"
      width="auto"
      height="auto"
      display="flex"
      flexDirection="column"
    >
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={openmsg}
        autoHideDuration={tms === 'error' ? null : 900}
        onClose={handleCloseMsg}
      >
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box
        component={Paper}
        sx={{
          width: '100%',
          maxWidth: 600,
          margin: 'auto',
          padding: 1
          
        }}
      >
        <NavBarRelatoriosEstoque />
        <DialogTitle>Relatório de Estoque</DialogTitle>
        <DialogContent dividers>
          {isLoading && (
            <Grid item>
              <LinearProgress variant='indeterminate' />
            </Grid>
          )}
          <Grid container spacing={2} padding={1}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Tipo</InputLabel>
                <Select
                  label="Tipo"
                  value={tipo}
                  size='small'
                  onChange={(e) => handleTipoChange(e.target.value)}
                >
                  <MenuItem value="geral">Geral</MenuItem>
                  <MenuItem value="grupo">Grupo</MenuItem>
                  <MenuItem value="subgrupo">Subgrupo</MenuItem>
                  <MenuItem value="minimo">Estoque Mínimo</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {(tipo === 'grupo' || tipo === 'subgrupo') && (
              <Grid item xs={12}>
                <AutoCompleteGrupoDeProdutos01
                  grupo={setGrupoNome}
                  uuidgrupo={handleGrupo}
                />

              </Grid>

            )}

            {tipo === 'subgrupo' && (
              <Grid item xs={12}>

                <AutoCompleteSubgrupoProdutos01
                  subgrupo={setSubgrupoNome}
                  idgrupo={grupo}
                  uuidsubgrupo={handleSubGrupo}

                />

              </Grid>

            )}

          </Grid>

        </DialogContent>


        <DialogActions>

          <Button
            sx={{ minWidth: '30%' }}
            variant='outlined'
            autoFocus
            onClick={handleSave}
          >

            Visualizar

          </Button>

        </DialogActions>

      </Box>

    </Box>

  );

};